module.exports = __webpack_public_path__ + "static/media/IMG-3.cdac4d01.jpg";